@if (showDeploymentBanner) {
<div class="deployment-banner">
  <div class="text">
    <div class="ddd-icon amber-flag-primary"></div>
    <span>
      We are undergoing planned maintenance
      <b
        >in
        <countdown #countdown [config]="{ leftTime: timeToDeployment }"></countdown>
        minutes</b
      >. Please make sure that all ongoing work is saved prior to then.</span
    >
  </div>
</div>
} @if (loggedUser) {
<header class="c-header">
  <div class="c-header__wrapper">
    <div class="c-header__logo"></div>
    <div class="c-header__body">
      @if (withMenu) {
      <div>
        <div class="inner">
          <nav role="navigation">
            <ul class="parent-list">
              @if (menuItems.dashboard) {
              <li class="parent-list-item">
                @if (menuItems.dashboard) {
                <a routerLink="/dashboard" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.DASHBOARD" | translate
                }}</a>
                }
              </li>
              } @if (menuItems.fmguest) {
              <li class="parent-list-item">
                <a routerLink="/fmguest" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.FMGUEST" | translate
                }}</a>
              </li>
              } @if (menuItems.assign) {
              <li class="parent-list-item">
                <a routerLink="/qc/assign" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.ASSIGN" | translate
                }}</a>
              </li>
              } @if (menuItems.completer) {
              <li class="parent-list-item">
                <a routerLink="/qc/complete" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.COMPLETE" | translate
                }}</a>
              </li>
              } @if (menuItems.releaser) {
              <li class="parent-list-item">
                <a routerLink="/qc/release" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.RELEASE" | translate
                }}</a>
              </li>
              } @if (menuItems.distributors || menuItems.analytics || menuItems.fmDistributors) {
              <li class="parent-list-item with-dropdown">
                <div class="item-menu" [ngClass]="{ active: checkActive() }">
                  <span>{{ "HEADER.DISTRIBUTORS" | translate }}</span>
                </div>
                <ul class="dropdown">
                  @if (menuItems.fmDistributors) {
                  <li>
                    <a routerLink="/fm-distributors" [routerLinkActive]="['active']" class="nav-item sub-link">{{
                      "HEADER.DISTRIBUTORS_DATA_GRID" | translate
                    }}</a>
                  </li>
                  } @if (menuItems.analytics) {
                  <li>
                    <a routerLink="/analytics" [routerLinkActive]="['active']" class="nav-item sub-link">{{
                      "HEADER.ANALYTICS" | translate
                    }}</a>
                  </li>
                  }
                </ul>
              </li>
              } @if (menuItems.manageTemplate) {
              <li class="parent-list-item">
                <a routerLink="/managetemplate" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.TEMPLATE_MANAGER" | translate
                }}</a>
              </li>
              } @if (menuItems.reviewGroups) {
              <li class="parent-list-item">
                <a routerLink="/reviewgroups" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.REVIEW_GROUPS" | translate
                }}</a>
              </li>
              } @if (menuItems.fundManagers) {
              <li class="parent-list-item">
                <a routerLink="/fundmanagers" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.FUND_MANAGERS" | translate
                }}</a>
              </li>
              } @if (menuItems.adminFMCompanies) {
              <li class="parent-list-item">
                <a routerLink="/support/fund-managers" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.FUND_MANAGERS" | translate
                }}</a>
              </li>
              } @if (menuItems.adminDistributorCompanies) {
              <li class="parent-list-item">
                <a routerLink="/support/distributors" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.DISTRIBUTORS" | translate
                }}</a>
              </li>
              } @if (menuItems.adminUsers) {
              <li class="parent-list-item">
                <a routerLink="/support/users" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.USERS" | translate
                }}</a>
              </li>
              } @if (menuItems.allinteractions) {
              <li class="parent-list-item">
                <a routerLink="allinteractions" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.ALL_INTERRACTIONS" | translate
                }}</a>
              </li>
              } @if (menuItems.alltasks) {
              <li class="parent-list-item">
                <a routerLink="/tasks" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.TASKS" | translate
                }}</a>
              </li>
              } @if (menuItems.adminEmails) {
              <li class="parent-list-item">
                <a routerLink="/support/emails" [routerLinkActive]="['active']" class="nav-item"
                  >{{ "HEADER.EMAILS" | translate
                  }}{{
                    loggedUser.newEmailsCount && loggedUser.newEmailsCount !== 0
                      ? " (" + loggedUser.newEmailsCount + ")"
                      : ""
                  }}</a
                >
              </li>
              } @if (menuItems.reporting || menuItems.fmanalytics) {
              <li class="parent-list-item with-dropdown">
                <div class="item-menu" [ngClass]="{ active: checkReportingActive() }">
                  <span>{{ "HEADER.REPORTING" | translate }}</span>
                </div>
                <ul class="dropdown">
                  @if (menuItems.reporting) {
                  <li>
                    <a routerLink="/reporting" [routerLinkActive]="['active']" class="nav-item sub-link">{{
                      "HEADER.REPORTS" | translate
                    }}</a>
                  </li>
                  } @if (menuItems.fmanalytics) {
                  <li>
                    <a routerLink="/fmanalytics" [routerLinkActive]="['active']" class="nav-item sub-link">{{
                      "HEADER.ANALYTICS_FM" | translate
                    }}</a>
                  </li>
                  }
                </ul>
              </li>
              } @if (menuItems.fmtasks) {
              <li class="parent-list-item">
                <a routerLink="/fmtasks" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.TASKS" | translate
                }}</a>
              </li>
              } @if (menuItems.documents) {
              <li class="parent-list-item">
                <a routerLink="/documents" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.DOCUMENTS" | translate
                }}</a>
              </li>
              } @if (menuItems.admin) {
              <li class="parent-list-item">
                <a routerLink="/admin" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.ADMIN" | translate
                }}</a>
              </li>
              } @if (menuItems.fmadmin) {
              <li class="parent-list-item">
                <a routerLink="/fmadmin" class="nav-item" [routerLinkActive]="['active']">{{
                  "HEADER.ADMIN" | translate
                }}</a>
              </li>
              } @if (menuItems.help) {
              <li class="parent-list-item">
                <a routerLink="/help" [routerLinkActive]="['active']" class="nav-item">{{
                  "HEADER.HELP" | translate
                }}</a>
              </li>
              }
            </ul>
          </nav>
        </div>
      </div>
      }
    </div>
    <div class="c-header__user-wrapper c-font--caption">
      <div class="c-header__username" title="{{ loggedUser.firstName + ' ' + loggedUser.lastName }}">
        {{ loggedUser.firstName + " " + loggedUser.lastName }}
      </div>
      <div class="c-header__company" title="{{ userCurrentCompany && userCurrentCompany.companyName }}">
        {{ userCurrentCompany && userCurrentCompany.companyName }}
      </div>
    </div>
    <div>
      <div class="c-button--hex-container c-button--hex-dropdown">
        <input type="checkbox" class="c-button--hex" id="my-dropdown" [(ngModel)]="menuDropdown" name="my-checkbox" />
        <div class="c-button--hex-text c-font--heavy-bold" data-toggle="dropdown">
          {{ loggedUser.firstName[0] + loggedUser.lastName[0] }}
        </div>
        <ul>
          <li class="menu-item" (click)="goToProfile()">
            {{ "HEADER.PROFILE" | translate }}
          </li>
          @if (!loggedUser.loginProviders) {
          <li class="menu-item" (click)="changePassword()">
            {{ "HEADER.CHANGE_PASSWORD" | translate }}
          </li>
          }
          <li class="menu-item" (click)="logout()">
            {{ "HEADER.LOGOUT" | translate }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
} @if (withCompanySelect && loggedUser && userCurrentCompany) {
<div class="c-sub-header change-distributor-dropdown">
  <div class="c-sub-header__dropdown c-font--caption">
    You are acting on behalf of:&nbsp;
    <span class="c-font--bold"> {{ userCurrentCompany.companyName }} ({{ userCurrentCompany.lei }}) </span>
    <button
      class="c-button__dropdown c-font--caption c-color--accent c-font--bold"
      [matMenuTriggerFor]="selectTemplate"
    >
      Change
    </button>
  </div>
  <mat-menu #selectTemplate="matMenu" class="right" xPosition="before">
    @for (company of loggedUser.companies; track company; let i = $index) {
    <button mat-menu-item (click)="changeCompany(company.companyId)">
      {{ company.companyName }} ({{ company.lei }})
    </button>
    }
  </mat-menu>
</div>
} @if ((isAdmin && withMenu) || (loggedUser && loggedUser.isSessionOpened)) {
<div class="common-header change-distributor-dropdown support-select">
  @if (!loggedUser.isSessionOpened) {
  <ng-select
    class="admin-company-list"
    [closeOnSelect]="true"
    [multiple]="false"
    [(ngModel)]="adminCurrentCompany"
    [items]="adminAllCompaniesList"
    (change)="adminCompanySelected()"
    bindLabel="fullname"
    bindValue="id"
    virtualScroll="true"
    notFoundText="Loading..."
    (search)="searchAdminCompanies($event)"
    (clear)="clearAdminSearch()"
    [searchFn]="customSearchFunction"
    (scrollToEnd)="fetchAdminCompanies()"
    placeholder="Click here to change Company"
  ></ng-select>
  } @if (!loggedUser.isSessionOpened && adminCurrentCompany) {
  <ng-select
    class="admin-user-list"
    [closeOnSelect]="true"
    [multiple]="false"
    [(ngModel)]="adminCurrentUser"
    [items]="adminCompanyUsersList"
    (change)="startAdminSession()"
    bindLabel="fullname"
    bindValue="id"
    placeholder="Click here to select user"
  ></ng-select>
  } @if (loggedUser.isSessionOpened) {
  <button class="ddd-button raised" (click)="endAdminSession()">End session</button>
  }
</div>
}
